import React from 'react'
import SchemaTag from '../SchemaTag.jsx'
import { object, string, bool } from 'prop-types'

class HotelStatsRichSnippets extends React.Component {
  getReviewsMetaDataFromFeed () {
    const { location } = this.props
    try {
      let feedData = this.getFeedPath()
      feedData.path = (location && location.name) ? feedData.path + location.code : feedData.path
      const meta = require('../../../../../config/exports/buildTimeOnly/reviews/' + feedData.path + '.json')
      return { meta, type: feedData.type, typeName: feedData.typeName }
    } catch (e) {
      return false
    }
  }

  getFeedPath () {
    const { pageData } = this.props
    switch (pageData.productClass.toUpperCase()) {
      case 'CP':
        return {
          path: 'parking/meta/',
          type: 1,
          typeName: 'parking'
        }
      case 'HCP':
        return {
          path: 'hotels/meta/',
          type: 2,
          typeName: 'hotels'
        }
      case 'HO':
        return {
          path: 'hotels/meta/',
          type: 2,
          typeName: 'hotels'
        }
      case 'LO':
        return {
          path: 'lounges/meta/',
          type: 3,
          typeName: 'lounges'
        }
      case 'INS':
        return {
          path: 'insurance/meta/meta',
          type: 4,
          typeName: 'insurance'
        }
    }

    return { }
  }

  render () {
    const { id, location, noSchemaMarkup } = this.props
    const data = this.getReviewsMetaDataFromFeed()
    let stringOne = (data && data.type === 4) ? ' Travel Insurance ' : ''
    let stringTwo = (data && data.type === 1) ? ' is rated ' : ' are rated '
    return (
      <SchemaTag tagType='p' noSchemaMarkup={noSchemaMarkup} id={id} className='leftList' itemScope itemType='http://schema.org/Product'>
        { data && data.meta && data.type && data.typeName && (
          <span>
            Our
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='name'>
              { location.name && (
                <span> {location.name} airport {data.typeName}</span>
              )}
            </SchemaTag>
            { stringOne }
            { stringTwo }
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} itemProp='aggregateRating' itemScope itemType='http://schema.org/AggregateRating'>
              <SchemaTag tagType='meta' noSchemaMarkup={noSchemaMarkup} itemProp='bestRating' content='100' />
              <SchemaTag tagType='meta' noSchemaMarkup={noSchemaMarkup} itemProp='worstRating' content='1' />
              <span className='priceSmall'>
                <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingValue'>{ data.meta.scoreAsPercentage }</SchemaTag>{'%'}
              </span>
              { ' by ' }
              <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingCount'>{ data.meta.reviewsWithComments }</SchemaTag>{ ' guests' }
            </SchemaTag>
          </span>
        ) }
      </SchemaTag>
    )
  }
}

HotelStatsRichSnippets.propTypes = {
  id: string.isRequired,
  location: object,
  pageData: object,
  noSchemaMarkup: bool
}

HotelStatsRichSnippets.defaultProps = {
  noSchemaMarkup: false,
  location: {
    code: false,
    name: false
  }
}

export default HotelStatsRichSnippets



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/reviews/comment-hotels-stats-richsnips.jsx